import { render, staticRenderFns } from "./PendenciasCriticas.vue?vue&type=template&id=13011e88&scoped=true"
import script from "./PendenciasCriticas.vue?vue&type=script&lang=js"
export * from "./PendenciasCriticas.vue?vue&type=script&lang=js"
import style0 from "./PendenciasCriticas.vue?vue&type=style&index=0&id=13011e88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13011e88",
  null
  
)

export default component.exports